<script setup lang="ts">
import { useEventListener } from "@vueuse/core";
import { useActiveChat } from "ls/api/cloud/ai";
import SimpleButton from "ls/components/simple-button/SimpleButton.vue";
import { computed } from "vue";
import AiChatRoot from "./AiChatRoot.vue";
import StreamingMarkdownViewer from "./StreamingMarkdownViewer.vue";

// const chat = computed(() => aiActiveContext.value ? useAiChat(aiActiveContext.value) : undefined);
const conversation = useActiveChat();
const lastMessage = computed(() => {
  if (conversation.value) {
    return conversation.value.messages.at(-1);
  }
  return undefined;
});

function insertDocument() {
  conversation.value?.triggerAction();
}

function clearConversation() {
  conversation.value?.finishConversation();
}

useEventListener(
  window,
  "keydown",
  (e: KeyboardEvent) => {
    if (e.key === "Escape") clearConversation();
  },
  { capture: true },
);
</script>

<template>
  <div
    v-if="conversation"
    class="fixed top-1/2 left-1/2 flex h-3/4
           w-3/4 -translate-x-1/2
           -translate-y-1/2
           items-center justify-center rounded-lg
           bg-white p-4 shadow-lg"
  >
    <div class="flex h-full w-full">
      <div class="h-full w-1/3">
        <AiChatRoot :chat-id="conversation.chatId" />
      </div>
      <div class="flex h-full w-2/3 flex-col">
        <div class="flex-1 overflow-y-auto">
          <StreamingMarkdownViewer v-if="lastMessage" :content="lastMessage.content" />
        </div>
        <!-- footer for button -->
        <div class="mt-4 flex justify-end">
          <SimpleButton
            class="rounded bg-blue-600 px-4 py-2 font-semibold text-white hover:bg-blue-700"
            :disabled="!lastMessage || lastMessage.isIncoming"
            @click="insertDocument"
          >
            Insert
          </SimpleButton>
        </div>
      </div>
    </div>
  </div>
</template>
